import { SET_ISTABLET, CLEAR_ISTABLET } from "./type";

// set isTablet state
export const setIsTablet = (isTablet) => ({
  type: SET_ISTABLET,
  payload: isTablet
});

// clear isTablet state
export const clearIsTablet = () => ({
  type: CLEAR_ISTABLET
});
